module.exports = __webpack_public_path__ + "static/img/img-klab-course.578fac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-klab-course.png
// module id = zBYc
// module chunks = 0